import React, { Children, ReactNode } from 'react';
import TwTimelineStep from './TwTimelineStep/TwTimelineStep';

export interface TwTimelineProps {
  /**
   * stepStartNumber
   * */
  stepStartNumber?: number;

  /**
   * things we don't want included as children/timeline stops
   * maybe there's a better way to do this so feel free to change -LR
   */
  other?: ReactNode;
  /**
   * children node
   */
  children: ReactNode;
}

const TwTimeline: React.FC<TwTimelineProps> = ({
  stepStartNumber,
  other,
  children
}): JSX.Element => {
  const arrayChildren = Children.toArray(children);

  return (
    <>
      {other}
      {arrayChildren.map((child, index) => {
        return (
          <TwTimelineStep
            key={index}
            stepNumber={(stepStartNumber ?? 1) + index}
            firstStep={index === 0}
            lastStep={index === arrayChildren.length - 1}
          >
            {child}
          </TwTimelineStep>
        );
      })}
    </>
  );
};

export default TwTimeline;
